import { reactive } from 'vue';

export type WebAppConfirmVariant = 'default' | 'destructive';

export interface WebAppConfirmOptions {
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  variant?: WebAppConfirmVariant;
}

export const webAppConfirmState = reactive({
  visible: false,
  title: '',
  message: '',
  confirmText: 'Confirm',
  cancelText: 'Cancel',
  variant: 'default' as WebAppConfirmVariant,
});

let resolveConfirm: ((value: boolean) => void) | null = null;

function finishConfirm(result: boolean) {
  webAppConfirmState.visible = false;

  if (resolveConfirm) {
    resolveConfirm(result);
    resolveConfirm = null;
  }
}

export function confirmWebAppDialog(result: boolean) {
  finishConfirm(result);
}

export function cancelWebAppDialog() {
  finishConfirm(false);
}

export function showWebAppConfirm(options: WebAppConfirmOptions): Promise<boolean> {
  if (webAppConfirmState.visible && resolveConfirm) {
    resolveConfirm(false);
  }

  return new Promise((resolve) => {
    resolveConfirm = resolve;
    webAppConfirmState.title = options.title;
    webAppConfirmState.message = options.message;
    webAppConfirmState.confirmText = options.confirmText ?? 'Confirm';
    webAppConfirmState.cancelText = options.cancelText ?? 'Cancel';
    webAppConfirmState.variant = options.variant ?? 'default';
    webAppConfirmState.visible = true;
  });
}

export function useWebAppConfirm() {
  return {
    webAppConfirmState,
    showWebAppConfirm,
    confirmWebAppDialog,
    cancelWebAppDialog,
  };
}
